const footerLinks = {
  Services: [
    { label: 'Solar Panels', href: '/solar' },
    { label: 'Battery Storage', href: '/battery' },
    { label: 'EV Chargers', href: '/ev-charger' },
    { label: 'Repairs & Servicing', href: '/#repairs' },
    { label: 'Maintenance Plans', href: '/#repairs' },
  ],
  'Areas Covered': [
    { label: 'London', href: '/#coverage' },
    { label: 'Essex', href: '/#coverage' },
    { label: 'Suffolk', href: '/#coverage' },
    { label: 'Cambridge', href: '/#coverage' },
    { label: 'Check your postcode', href: '/#quote-section' },
  ],
  'Company': [
    { label: 'About Us', href: '/contact' },
    { label: 'Our Projects', href: '/projects' },
    { label: 'Reviews', href: '#' },
    { label: 'Contact Us', href: '/contact' },
    { label: 'Careers', href: '/contact' },
  ],
};

const certifications = ['MCS Certified', 'NAPIT Approved', 'OZEV Authorised', 'TrustMark', 'Which? Trusted'];

export default function Footer() {
  return (
    <footer className="bg-[#1F2933] text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/ee62e899e0ea98d48397a860148ed960.png"
              alt="Renewables Made Easy"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-5 max-w-xs">
              Specialists in commercial &amp; residential EV charging installation. Covering London, Essex, Suffolk and Cambridge. Fixed prices, certified engineers.
            </p>
            {/* Contact */}
            <div className="flex flex-col gap-2">
              <a href="tel:08001234567" className="flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-[#7AC943] text-sm" />
                </div>
                0800 123 4567
              </a>
              <a href="mailto:hello@renewablesmadeeasy.co.uk" className="flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-fill text-[#7AC943] text-sm" />
                </div>
                hello@renewablesmadeeasy.co.uk
              </a>
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-[#7AC943] text-sm" />
                </div>
                London · Essex · Suffolk · Cambridge
              </div>
            </div>
          </div>

          {/* Links columns */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h4 className="font-heading font-bold text-white text-sm mb-4 uppercase tracking-wide">
                <a href="#">{section}</a>
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
                      rel="nofollow"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Certifications */}
        <div className="mt-10 pt-8 border-t border-white/10">
          <p className="text-white/40 text-xs uppercase tracking-widest mb-4">Certifications &amp; Approvals</p>
          <div className="flex flex-wrap gap-3">
            {certifications.map((cert) => (
              <span
                key={cert}
                className="flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-full px-3 py-1.5 text-xs text-white/70"
              >
                <i className="ri-medal-fill text-[#7AC943]" />
                {cert}
              </span>
            ))}
          </div>
        </div>

        {/* Partner Companies */}
        <div className="mt-8 pt-8 border-t border-white/10">
          <p className="text-white/40 text-xs uppercase tracking-widest mb-5">Partner Companies</p>
          <div className="flex flex-wrap items-center gap-6">
            <a
              href="https://evmadeeasy.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#7AC943]/40 rounded-2xl px-5 py-4 transition-all duration-200 cursor-pointer"
            >
              <img
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/9e1c45fda1af1a03c9dffd9e224cef24.png"
                alt="EV Made Easy"
                className="h-12 w-auto object-contain"
              />
              <div>
                <div className="text-white font-bold text-sm group-hover:text-[#7AC943] transition-colors">EV Made Easy</div>
                <div className="text-white/50 text-xs mt-0.5">Specialist EV charger installers</div>
                <div className="flex items-center gap-1 mt-1.5">
                  <span className="text-[#7AC943] text-[10px] font-semibold">evmadeeasy.co.uk</span>
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-external-link-line text-[#7AC943] text-[10px]" />
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs text-center sm:text-left">
            &copy; 2025 Renewables Made Easy Ltd. Registered in England &amp; Wales. All rights reserved.
          </p>
          <div className="flex items-center flex-wrap justify-center gap-4 sm:gap-5">
            <a href="#" className="text-white/40 hover:text-white/70 text-xs transition-colors cursor-pointer" rel="nofollow">Privacy Policy</a>
            <a href="#" className="text-white/40 hover:text-white/70 text-xs transition-colors cursor-pointer" rel="nofollow">Terms of Service</a>
            <a href="#" className="text-white/40 hover:text-white/70 text-xs transition-colors cursor-pointer" rel="nofollow">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
